import dynamic from "next/dynamic"
import { PassTicketsFeatures } from "../features"

const Lottie = dynamic(() => import("lottie-react"), {
    ssr: false,
})

const ServiceCardMobile = ({
    service,
    media,
    description,
}: PassTicketsFeatures) => {
    return (
        <>
            <div className="flex h-24 w-full rounded-3xl bg-white md:hidden">
                <div className="grid h-full w-full grid-cols-3 items-center justify-center rounded-[10px] px-2">
                    <div className="col-span-1 flex h-16 w-20 items-center justify-center hover:bg-red-400">
                        <Lottie
                            loop={false}
                            animationData={media}
                            className="h-[180px] w-[180px] md:h-[300px] md:w-[300px]"
                        />
                    </div>
                    <div className="col-span-2 flex flex-col gap-2">
                        <p className="truncate text-sm font-bold text-black">
                            {service}
                        </p>
                        <p className="text-xs font-light leading-normal text-black">
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceCardMobile
